import { Component, OnInit, Input } from '@angular/core';
import {CronOptions} from 'cron-editor/lib/CronOptions';

@Component({
  selector: 'ap-scm-manager',
  templateUrl: './source-code-management-settings.component.html',
  styleUrls: ['./source-code-management-settings.component.scss']
})
export class SourceCodeManagementSettingsComponent implements OnInit {

  scmSystem = 'git';

  // repositoryUrl, branchSpecifier
  @Input() externalTestsuiteConfigs: any;


  scmSystems = [
    {value: 'git', displayName: 'Git'}
  ];

  constructor() { }

  ngOnInit() {
  }

}
